import { __awaiter } from "tslib";
import { WrapWritableStream } from "@yume-chan/adb";
import { DEFAULT_SERVER_PATH } from "./options/index.js";
export function pushServer(device, options = {}) {
    const { path = DEFAULT_SERVER_PATH } = options;
    let sync;
    return new WrapWritableStream({
        start() {
            return __awaiter(this, void 0, void 0, function* () {
                sync = yield device.sync();
                return sync.write(path);
            });
        },
        close() {
            return __awaiter(this, void 0, void 0, function* () {
                yield sync.dispose();
            });
        },
    });
}
//# sourceMappingURL=push-server.js.map